import { TooltipDirective } from '@accesso/adk-portal-shared';
import { ChipComponent } from '@accesso/ng-uds';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, ViewChild } from '@angular/core';
import { NavigationProduct, ProductStatus } from '../../../shared/models/product.model';
import { CardComponent } from '../../card/card.component';

@Component({
  selector: 'app-product-card-item',
  templateUrl: './product-card-item.component.html',
  styleUrls: ['./product-card-item.component.scss'],
  standalone: true,
  imports: [CommonModule, CardComponent, TooltipDirective, ChipComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductCardItemComponent implements AfterViewInit {
  @Input() product: NavigationProduct;

  @ViewChild('header') headerRef: ElementRef;

  isOverflowing = false;

  ProductStatus = ProductStatus;

  selectedDescription: string;

  ngAfterViewInit(): void {
    this.checkHeaderOverflow();
  }

  checkHeaderOverflow(): void {
    if (this.headerRef && this.headerRef.nativeElement) {
      this.isOverflowing = this.headerRef.nativeElement.scrollWidth > this.headerRef.nativeElement.clientWidth;
    }
  }
}
